export class TaskMessageModalMovePaymentData {
  originTaskId: number;
  isUnhandledRecoveryPaymentTask: boolean;
}
